<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.transportation.form.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.transportation.form.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.transportation.form.shippingCost')" prop="shippingCost">
                  <a-input v-model="queryParam.shippingCost" :placeholder="$t('views.transportation.form.shippingCostPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.transportation.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.transportation.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.transportation.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.transportation.btn.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:transportation:add']">
          <a-icon type="plus" />{{ $t('views.transportation.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:transportation:edit']">
          <a-icon type="edit" />{{ $t('views.transportation.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:transportation:remove']">
          <a-icon type="delete" />{{ $t('views.transportation.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:transportation:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:transportation:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['user:transportation:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:transportation:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="showPaginationTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTransportation,listTransportation, delTransportation, updateTransportation } from '@/api/user/transportation'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Transportation',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        nameEn: null,
        shippingCost: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'nameEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'shippingCost',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    displayColumns () {
      const titleKeyByDataIndex = {
        id: 'views.transportation.column.id',
        name: 'views.transportation.column.name',
        nameEn: 'views.transportation.column.nameEn',
        shippingCost: 'views.transportation.column.shippingCost',
        sort: 'views.transportation.column.sort',
        status: 'views.transportation.column.status',
        createTime: 'views.transportation.column.createTime',
        operation: 'views.transportation.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  watch: {
  },
  methods: {
    showPaginationTotal (total) {
      return this.$t('views.transportation.pagination.total', { total })
    },
    /** 查询运输方式列表 */
    getList () {
      this.loading = true
     pageTransportation(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        nameEn: undefined,
        shippingCost: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      const idsText = Array.isArray(ids) ? ids.join(',') : String(ids)
      this.$confirm({
        title: this.$t('views.transportation.confirm.deleteTitle'),
        content: this.$t('views.transportation.confirm.deleteContent', { ids: idsText }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delTransportation(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.transportation.msg.deleteOk'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.transportation.confirm.exportTitle'),
        content: this.$t('views.transportation.confirm.exportContent'),
        onOk () {
          that.download('user/transportation/export', {
            ...that.queryParam
          }, that.$t('views.transportation.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateTransportation(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.transportation.msg.statusUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.transportation.msg.statusUpdateFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateTransportation(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.transportation.msg.sortUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.transportation.msg.sortUpdateFail'))
      })
    }
  }
}
</script>
